import React, { useCallback, useEffect, useState } from "react";

function Wiki(props) {
  const [info, setInfo] = useState();
  const [moreInfo, setMoreInfoURL] = useState(null);
  const [image, setImageURL] = useState();

  // const url = encodeURI(
  //   "https://en.wikipedia.org/api/rest_v1/page/summary/" +
  //     props.previousStep.value
  // );

  const fetchWiki = useCallback(() => {
    fetch(
      encodeURI(
        "https://en.wikipedia.org/api/rest_v1/page/summary/" +
          props.previousStep.value
      )
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.extract !== undefined) {
          setInfo(data.extract);
        }

        if (data.originalimage !== undefined) {
          setImageURL(data.originalimage.source);
        }

        if (data.content_urls !== undefined) {
          setMoreInfoURL(data.content_urls.desktop.page);
        }

        if (data.detail !== undefined) {
          setInfo(data.detail);
        }
      });
  }, []);

  useEffect(() => {
    fetchWiki();
  }, []);

  return (
    <>
      <p className="text-dark">
        <img src={image} width="100%" alt="" />
        <br />
        <br />
        {info}
        <br />
        <br />
        {moreInfo !== null ? "For more information: " + moreInfo : null}
      </p>
    </>
  );
}

export default Wiki;
